export default __webpack_public_path__ + "static/media/copy.ee8f410c.svg";